import styled from 'styled-components';
import { Col, } from 'antd';

export const Container = styled.div`
  height: 100%;

  p {
    color: #fff;
  }
`;

export const Box = styled(Col)`
  background-color: #ccc;
  padding: 30px;
  border-radius: 15px;
`;


